module.exports = __webpack_public_path__ + "static/media/gagnefvapen.9a01afe2.png";